import lang from '../../../lang/index.js';
import validation from '../../index.js';
export default function phoneNumber({ allowInternational } = { allowInternational: false }) {
    if (allowInternational) {
        throw new validation.ValidationError('International numbers not yet supported');
    }
    return this
        .matches(/^\d{3}-\d{3}-\d{4}$/, lang().validation.phoneNumberUs);
}
//# sourceMappingURL=index.js.map